import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { getHorseRacingRunner } from 'src/domains/sportsbook/webview/components/raceSummary/utils/Utils';
import {
    JockeyAndTrainerDetailsBox,
    RunnerCell,
    RunnerCellDetails,
    SelectionWrapper,
    SilkCellRaceBox,
} from 'src/domains/sportsbook/webview/components/racesSlider/horseRacing/cardBodyItem/CardBodyItem.style';
import { WidgetSilk } from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetSilk';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CardBodyItemPropsType {
    selectionId: SelectionId;
    specialEvent?: boolean;
}

export const CardBodyItem = observer('CardBodyItem', ({ selectionId, specialEvent }: CardBodyItemPropsType) => {
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;
    const common = useCommon();
    const configState = ConfigComponents.get(common).unifiedComponentConfig;

    if (selection === null || market === null) {
        return null;
    }

    const isUnnamedFavourite = selection.templateId === 'unnamed-favourite';
    const silkUrl = selection.metaDataSilkUrl ?? '';
    const silkAltDesc = selection.metaDataSilk ?? '';

    const runner = getHorseRacingRunner(selection, isUnnamedFavourite);

    const isDetailsAvailable = isUnnamedFavourite === false;

    if (specialEvent === true) {
        return (
            <>
                <WidgetSilk selectionId={selectionId} />

                <RunnerCellDetails>{runner}</RunnerCellDetails>

                <SelectionWrapper
                    borderLeft={true}
                    selectionId={selectionId}
                    variant={configState.componentVariants.raceCardVariant}
                />
            </>
        );
    }

    return (
        <>
            <RunnerCell>
                <SilkCellRaceBox
                    alt={silkAltDesc}
                    imgBase={{
                        src: silkUrl,
                        optimizeOptions: {
                            quality: 85,
                            width: 54,
                        },
                    }}
                />

                <JockeyAndTrainerDetailsBox
                    selectionId={selectionId}
                    isDetailsAvailable={isDetailsAvailable}
                />
            </RunnerCell>

            <SelectionWrapper
                borderLeft={true}
                selectionId={selectionId}
                variant={configState.componentVariants.raceCardVariant}
            />
        </>
    );
});
